import { notReadMessage } from "@/service/message";
import { getLoginStateValue, setLoginStateValue } from "@/utils/auth";
import { defineStore } from "pinia";
export const appCounterStore = defineStore("app", {
    state: () => ({
        loginState: getLoginStateValue() || "login",
        sidebar: false,
        msgTotal: 0,
        billingId: ""
    }),
    getters: {
        getLoginState(state) {
            return state.loginState;
        },
        getSidebar(state) {
            return state.sidebar;
        },
        getMsgTotal(state) {
            return state.msgTotal;
        },
        getBillingId(state) {
            return state.billingId;
        }
    },
    actions: {
        setLoginState(value) {
            this.loginState = value;
            setLoginStateValue(value);
        },
        setSidebar(value) {
            this.sidebar = value;
        },
        setBillingId(value) {
            this.billingId = value;
        },
        getUnReadMessageCount() {
            return new Promise((resolve) => {
                notReadMessage().then((res) => {
                    this.msgTotal = res.data.total;
                    resolve(res.data.total);
                });
            });
        },
        setMsgTotal(value) {
            this.msgTotal = value;
        }
    }
});
